module.exports = __webpack_public_path__ + "static/AustriasNextTopStartup2018-bbcae69c007fd3f26966b8dad556fd80.png";